import { Button, IconButton, useMediaQuery, useTheme } from '@mui/material';
import React, { FC } from 'react';
import LockIcon from '@mui/icons-material/Lock';
import { useStyles } from './PassphraseIndicator.styles';

export const PassphraseIndicator: FC = () => {
  const theme = useTheme();
  const { classes } = useStyles();
  const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <>
      {fullScreen ? (
        <IconButton aria-label="share">
          <LockIcon fontSize="medium" />
        </IconButton>
      ) : (
        <Button size="small" className={classes.button} startIcon={<LockIcon fontSize="medium" />}>
          Passphrase Protected
        </Button>
      )}
    </>
  );
};
